(function () {

    'use strict';
    angular.module('app')
        .controller('exportAccountsController', ['$scope', '$uibModalInstance', '$location', 'exportAccountsService', exportAccountsController]
            );

    function exportAccountsController($scope, $uibModalInstance, $location, exportAccountsService) {
        $scope.model = [];
        var date = new Date();
        date.setMonth(date.getMonth() - 1);
        $scope.model.startDate = date;

        $scope.model.endDate = new Date();


        $scope.submitExport = function () {
            if ($scope.model.startDate && $scope.model.endDate) {
                $scope.model.Loading = true;
                exportAccountsService.exportAccounts($scope.model.startDate, $scope.model.endDate)
                    .then(function (response) {
                        $scope.model.url = response.url;
                        $scope.model.filename = response.fileName;
                        $scope.model.showDownload = true;
                        $scope.model.Loading = false;
                    });
            }
        };
        $scope.today = function () {
            $scope.dt = new Date();

        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        $scope.inlineOptions = {
            customClass: getDayClass,
            minDate: new Date(),
            showWeeks: true
        };

        $scope.dateOptions = {
            format: 'dd/MM/yyyy',
            maxDate: new Date(2020, 5, 22),
            minDate: new Date(),
            startingDay: 1
        };


        $scope.toggleMin = function () {
            $scope.inlineOptions.minDate = $scope.inlineOptions.minDate ? null : new Date();
            $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
        };

        $scope.toggleMin();

        $scope.open1 = function () {
            $scope.popup1.opened = true;
        };

        $scope.open2 = function () {
            $scope.popup2.opened = true;
        };

        $scope.setDate = function (year, month, day) {
            $scope.dt = new Date(year, month, day);
        };


        $scope.format = 'dd/MM/yyyy';


        $scope.popup1 = {
            opened: false
        };

        $scope.popup2 = {
            opened: false
        };

        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        var afterTomorrow = new Date();
        afterTomorrow.setDate(tomorrow.getDate() + 1);
        $scope.events = [
            {
                date: tomorrow,
                status: 'full'
            },
            {
                date: afterTomorrow,
                status: 'partially'
            }
        ];

        function getDayClass(data) {
            var date = data.date,
                mode = data.mode;
            if (mode === 'day') {
                var dayToCheck = new Date(date).setHours(0, 0, 0, 0);

                for (var i = 0; i < $scope.events.length; i++) {
                    var currentDay = new Date($scope.events[i].date).setHours(0, 0, 0, 0);

                    if (dayToCheck === currentDay) {
                        return $scope.events[i].status;
                    }
                }
            }

            return '';
        }


    }
})();